import { event } from './const';
import { logOnServerDebugInfo } from './utils';

const get = (node, target) => node.querySelectorAll(target);

const parser = new DOMParser();

function createVastParser(urlPreparingFunc, emitter, saveVastContentOnServer = false, timeout) {
  const fetchTimeout = (timeout, tid) => {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), timeout);
  
    return controller.signal;
  }

  return function (url, tid, shouldBePrepared = false) {
    const preparedUrl = shouldBePrepared ? urlPreparingFunc(url, false) : url;

    return fetch(preparedUrl, { credentials: 'include', mode: 'cors', signal: fetchTimeout(timeout, tid) })
      .then(vastResponse => vastResponse.text())
      .then(vastText => {
        emitter.emit(event.Player.PlayerLog, `parsed VAST(${tid}): `, vastText);

        saveVastContentOnServer && logOnServerDebugInfo(vastText, tid);

        return parser.parseFromString(vastText, "application/xml");
      }).catch(error => {
        console.log(`Failed to fetch VAST (${preparedUrl}): ${error}`);
        emitter.emit(event.Player.TagCompleteRequest, { tid, success: false });
      });
  }
}

export { createVastParser, get };